export default __webpack_public_path__ + "static/media/about2.87124537.svg";